import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'ligue1';
const { variant, uniform, visitorOnly } = leagueBuilder(ID);

const teams = [
  team('angers', 'Angers', [variant('#000000', 'angers'), visitorOnly('#FFFFFF', 'angers')]),
  team('auxerre', 'Auxerre', [variant('#000000', 'auxerre'), visitorOnly('#FFFFFF', 'auxerre')]),
  team('brest', 'Brest', [variant('#EC1E25', 'brest'), visitorOnly('#FFFFFF', 'brest')]),
  team('le-havre', 'Le Havre AC', [variant('#79BCE7', 'le-havre'), visitorOnly('#BA965C', 'le-havre')]),
  team('le-mans', 'Le Mans FC', [variant('#BA091A', 'le-mans'), visitorOnly('#E8B501', 'le-mans')]),
  team('lens', 'RC Lens', [variant('#ED1C24', 'lens'), visitorOnly('#FFF200', 'lens')]),
  team('lille', 'Lille', [variant('#E01E13', 'lille'), visitorOnly('#FFFFFF', 'lille')]),
  team('lorient', 'FC Lorient', [variant('#F68113', 'lorient'), visitorOnly('#231F20', 'lorient')]),
  team('metz', 'FC Metz', [variant(['#87070B', '#FFFFFF'], 'metz')]),
  team('as-monaco', 'AS Mónaco', [variant('#FF0232', 'as-monaco'), visitorOnly('#FFFFFF', 'as-monaco')]),
  team('montpellier', 'Montpellier', [variant('#005CA6', 'montpellier'), visitorOnly('#FF932D', 'montpellier')]),
  team('nantes', 'FC Nantes', [variant('#02A558', 'nantes'), visitorOnly('#FFFFFF', 'nantes')]),
  team('niza', 'Niza', [variant('#E60000', 'niza'), visitorOnly('#000000', 'niza')]),
  team('lyon', 'Lyon', [variant('#1112AB', 'lyon'), visitorOnly('#F11538', 'lyon')]),
  team('o-marseille', 'Marseille', [variant(['#0061B1', '#FFFFFF'], 'o-marseille')]),
  team('paris-fc', 'Paris FC', [variant('#000F3C', 'paris-fc'), visitorOnly('#FFFFFF', 'paris-fc')]),
  team('psg', 'PSG', uniform('psg', '#D53C42', '#FFFFFF')),
  team('strasbourg', 'Strasbourg', uniform('strasbourg', '#00AEEF', '#E03A3E')),
  team('rennes', 'Rennes', uniform('rennes', '#E13327', '#000000')),
  team('reims', 'Reims', [variant(['#FF0000', '#FFFFFF'], 'reims')]),
  team('saint-etienne', 'Saint-Étienne', uniform('saint-etienne', '#1D995B', '#FFFFFF')),
  team('troyes', 'Troyes', uniform('troyes', '#003168', '#FFFFFF')),
  team('toulouse', 'Toulouse', uniform('toulouse', '#7E5A93', '#FAE100'))
];

export const ligue1: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(36, 44, 270, 342) },
  teams
};
